import React from 'react';

export default function BrandingPlanJakamen() {
  // Jakamen branding plan data (copied from BrandingForecastSWOT3453534.jsx)
  const brandingPlanRows = [
    // YouTube (CPV)
    { channel: 'YouTube', targeting: 'Dizi', budget: 55000, metric: 'CPV', unitCost: 0.20 },
    { channel: 'YouTube', targeting: 'Finans', budget: 10000, metric: 'CPV', unitCost: 0.20 },
    { channel: 'YouTube', targeting: 'Haber', budget: 10000, metric: 'CPV', unitCost: 0.20 },
    { channel: 'YouTube', targeting: 'Futbol', budget: 10000, metric: 'CPV', unitCost: 0.20 },
    // Google Display Network (CPM)
    { channel: 'Google Display Network', targeting: 'Finans', budget: 5000, metric: 'CPM', unitCost: 35 },
    { channel: 'Google Display Network', targeting: 'Futbol', budget: 7500, metric: 'CPM', unitCost: 35 },
    { channel: 'Google Display Network', targeting: 'Haber', budget: 3000, metric: 'CPM', unitCost: 35 },
    // TV (CPV)
    { channel: 'Kanal D', targeting: 'Uzak Şehir', budget: 22000, metric: 'CPV', unitCost: 0.60 },
    { channel: 'Kanal D', targeting: 'Eşref Rüya', budget: 25000, metric: 'CPV', unitCost: 0.60 },
    { channel: 'Show TV', targeting: 'Veliaht', budget: 15000, metric: 'CPV', unitCost: 0.68 },
    { channel: 'TRT 1', targeting: 'Teşkilat', budget: 20000, metric: 'CPV', unitCost: 0.60 },
    { channel: 'TRT 1', targeting: 'Taşacak Bu Deniz', budget: 7500, metric: 'CPV', unitCost: 0.60 },
    { channel: 'TRT 1', targeting: 'Fetihler Sultanı', budget: 15000, metric: 'CPV', unitCost: 0.60 },
    // Pinterest (CPM)
    { channel: 'Pinterest', targeting: 'Interest', budget: 35000, metric: 'CPM', unitCost: 30 },
  ];

  const formatTL = (n, fd = 0) => `₺${Number(n || 0).toLocaleString('tr-TR', { minimumFractionDigits: fd, maximumFractionDigits: fd })}`;
  const formatInt = (n) => Number(Math.round(n || 0)).toLocaleString('tr-TR');

  const channelLogos = {
    'YouTube': '/youtubelogo222.png',
    'Pinterest': '/pinterestlogo.png',
    'Google Display Network': '/google_ads-512.webp',
    'Meta': '/6033716.png',
    'TikTok': '/tiktokv4.svg',
    'Kanal D': '/kanaldlogo.png',
    'Show TV': '/showtvlogo.jpeg',
    'TRT 1': '/TRT1logo.png',
  };

  const computedRows = brandingPlanRows.map(r => {
    const views = r.metric === 'CPV' ? (r.budget / r.unitCost) : null;
    const impressions = r.metric === 'CPM' ? ((r.budget / r.unitCost) * 1000) : null;
    return { ...r, views, impressions };
  });

  const groupedByChannel = computedRows.reduce((acc, r) => {
    if (!acc[r.channel]) acc[r.channel] = [];
    acc[r.channel].push(r);
    return acc;
  }, {});

  const grandTotals = computedRows.reduce((acc, r) => {
    acc.budget += r.budget;
    acc.views += (r.views || 0);
    acc.impressions += (r.impressions || 0);
    return acc;
  }, { budget: 0, views: 0, impressions: 0 });

  return (
    <div className="p-6 bg-[#F7F8FC] min-h-screen">
      <div className="bg-white rounded-xl shadow-sm border overflow-hidden w-full max-w-6xl mx-auto">
        <div className="px-5 py-4 flex justify-between items-center bg-black text-white">
          <h2 className="text-base font-semibold text-white">Branding Plan</h2>
          <img src="/jakamenlogo.webp" alt="Jakamen Logo" className="h-7 w-auto object-contain" />
        </div>
        <div className="overflow-x-auto">
          <table className="min-w-full">
            <thead className="bg-gray-50">
              <tr className="border-b border-gray-200">
                <th className="px-4 py-2 text-left text-[11px] font-medium text-gray-600 uppercase tracking-wide" style={{ width: '18%' }}>Channel</th>
                <th className="px-4 py-2 text-left text-[11px] font-medium text-gray-600 uppercase tracking-wide" style={{ width: '24%' }}>Targeting</th>
                <th className="px-4 py-2 text-center text-[11px] font-medium text-gray-600 uppercase tracking-wide" style={{ width: '10%' }}>Metric</th>
                <th className="px-4 py-2 text-right text-[11px] font-medium text-gray-600 uppercase tracking-wide" style={{ width: '12%' }}>Unit Cost</th>
                <th className="px-4 py-2 text-right text-[11px] font-medium text-gray-600 uppercase tracking-wide" style={{ width: '14%' }}>Budget</th>
                <th className="px-4 py-2 text-right text-[11px] font-medium text-gray-600 uppercase tracking-wide" style={{ width: '11%' }}>Est. Views</th>
                <th className="px-4 py-2 text-right text-[11px] font-medium text-gray-600 uppercase tracking-wide" style={{ width: '11%' }}>Est. Impr.</th>
              </tr>
            </thead>
            <tbody className="bg-white">
              {Object.keys(groupedByChannel).map(channel => {
                const rows = groupedByChannel[channel];
                return rows.map((r, idx) => (
                  <tr key={`${channel}-${idx}`} className={`border-b border-gray-100 ${idx % 2 === 1 ? 'bg-gray-50' : 'bg-white'}`}>
                    {idx === 0 ? (
                      <td className="px-4 py-3 text-sm font-medium text-gray-900 align-middle" rowSpan={rows.length}>
                        <div className="flex items-center gap-2">
                          {channelLogos[channel] && (
                            <img src={channelLogos[channel]} alt={`${channel} logo`} className="w-4 h-4 object-contain" />
                          )}
                          <span>{channel}</span>
                        </div>
                      </td>
                    ) : null}
                    <td className="px-4 py-3 text-sm text-gray-700">{r.targeting}</td>
                    <td className="px-4 py-3 text-sm text-center text-gray-700">{r.metric}</td>
                    <td className="px-4 py-3 text-sm text-right text-gray-700">{r.metric === 'CPM' ? formatTL(r.unitCost) : formatTL(r.unitCost, 2)}</td>
                    <td className="px-4 py-3 text-sm text-right font-semibold text-gray-900">{formatTL(r.budget)}</td>
                    <td className="px-4 py-3 text-sm text-right text-gray-700">{r.views != null ? formatInt(r.views) : '-'}</td>
                    <td className="px-4 py-3 text-sm text-right text-gray-700">{r.impressions != null ? formatInt(r.impressions) : '-'}</td>
                  </tr>
                ));
              })}
              <tr className="bg-gray-100 font-semibold">
                <td className="px-4 py-3 text-sm" colSpan={4}>TOTAL</td>
                <td className="px-4 py-3 text-sm text-right text-gray-900">{formatTL(grandTotals.budget)}</td>
                <td className="px-4 py-3 text-sm text-right text-gray-900">{formatInt(grandTotals.views)}</td>
                <td className="px-4 py-3 text-sm text-right text-gray-900">{formatInt(grandTotals.impressions)}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="px-4 py-3 text-[11px] text-gray-500 bg-gray-50 border-t">
          Varsayımlar: YouTube & Video CPV değerleri {formatTL(0.20, 2)} ve {formatTL(0.18, 2)} olarak, Display & Pinterest CPM değerleri {formatTL(35)} ve {formatTL(30)} olarak alınmıştır. İstenirse hızlıca güncelleyebilirim.
        </div>
      </div>
    </div>
  );
}


